var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDummy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visuals",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Task-List---Unassigned-Copy-3",
    transform: "translate(-42.000000, -387.000000)",
    stroke: "#000000",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(42.000000, 206.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c-pulse",
    transform: "translate(1.000000, 181.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "0 8.8 2.8 8.8 4.4 4.8 7.2 12.8 8.8 8.8 12 8.8"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummy);
export default __webpack_public_path__ + "static/media/dummy.65cace0d9aaf2b26a2b157f0006fac2c.svg";
export { ForwardRef as ReactComponent };